module.exports = __webpack_public_path__ + "static/media/tds-logo.38f482ef.png";